/**
 * 헤더 지역 선택기 — 클라이언트에서도 쓰는 순수 부분(경로 매칭·placeholder). 서버 전용 import 없음.
 * 데이터 생성은 ./header-region.ts (서버·layout).
 */
import type { PickerTop } from '@/components/ds/v3/RegionPickerClient';

export interface HeaderRegionData {
  tops: PickerTop[];
  /** [디코드된 경로, 지역 코드] — 앞선 항목이 이긴다(시·군이 시/도보다 먼저). */
  paths: [string, string][];
}

export const EMPTY_HEADER_REGION: HeaderRegionData = { tops: [], paths: [] };

/** URL 경로 정규화: 퍼센트 디코드(실패 시 원문) · 끝 슬래시 제거. 한글 slug 가 인코드/디코드 두 형태로 온다. */
export function normPath(p: string | null | undefined): string {
  let s = String(p ?? '').split(/[?#]/)[0];
  try { s = decodeURIComponent(s); } catch { /* 깨진 인코딩 — 원문 */ }
  if (s.length > 1) s = s.replace(/\/+$/, '');
  return s;
}

/** 경로 → 현재 지역 trail(상위부터). 허브 경로가 아니면 [] (= 전국). */
export function matchHeaderRegion(pathname: string | null | undefined, data: HeaderRegionData | null | undefined): { code: string; label: string }[] {
  if (!data || !data.tops.length) return [];
  const p = normPath(pathname);
  if (!p.startsWith('/apt/')) return [];
  const hit = data.paths.find(([k]) => k === p);
  if (!hit) return [];
  const code = hit[1];
  for (const t of data.tops) {
    if (t.code === code) return [{ code: t.code, label: t.label }];
    const c = t.children.find((k) => k.code === code);
    if (c) return [{ code: t.code, label: t.label }, { code: c.code, label: c.label }];
  }
  return [];
}

/** 검색창 placeholder — 지역을 따른다. 전국이면 기본 문구(fallback). */
export function headerSearchPlaceholder(regionName: string | null | undefined, fallback: string): string {
  const n = (regionName ?? '').trim();
  return n ? `${n} 단지명·지역 검색` : fallback;
}
